// extracted by mini-css-extract-plugin
export var titleSection = "title_section-module--titleSection--1xLUX";
export var title = "title_section-module--title--3BWMr";
export var description = "title_section-module--description--2s3JU";